import FilterCheckbox from "@/common/components/FilterCheckbox";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterFuelProductsOnlyBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  return (
    <FilterCheckbox
      id='fuel_products_only'
      name='fuel_products_only'
      label={dashboardFilters[DashboardFilters.FuelProductsOnly]}
      containerClassName="bg-blue-200/20 rounded-xl shadow-none text-nowrap"
      isChecked={!!filters[DashboardFilters.FuelProductsOnly]}
      onChange={(value) => setFilters((prev) => ({ ...prev, [DashboardFilters.FuelProductsOnly]: value ? true : null }))}
    />
  );
}

export default DashboardFilterFuelProductsOnlyBadge;
